export const SET_SEARCH_RESULTS = 'last-minute/SET_SEARCH_RESULTS';
export const UPDATE_HOTELS_INFO = 'last-minute/UPDATE_HOTELS_INFO';
